module.exports = __webpack_public_path__ + "img/img-148.9a379138.png";